import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { GuardianNotificationRegService } from "./guardiannotificationreg.service";
import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { wsGuardianNotificationInfo } from "./wsGuardianNotificationInfo";

import * as moment from "moment";

@Component({
	selector: "caass-student-guardiannotification",
	templateUrl: "./guardiannotificationreg.component.html",
	styleUrls: ["./guardiannotificationreg.component.css"],
})

//-----------------------------------------------------------------------------------------------------
//
//	GuardianNotificationRegComponent
//
//-----------------------------------------------------------------------------------------------------
export class GuardianNotificationRegComponent implements OnInit, OnDestroy {
	subscription: Subscription;
	isBusy: boolean = true;
	isKeyGenerated: boolean = false;
	user: any;
	selectedStudent: any;
	GuardianList: any;
	SaveDone = "";
	SaveErrorMessage = "";
	NotificationDisabledMessage = "";

	public IsNotificationsForSchoolEnabled: boolean = false;
	public IsStudentSchoolNotificationEnabled: boolean = false;

	public wsGuardianNotificationInfo: wsGuardianNotificationInfo;

	public lstNotifyLanguages: any = [];
	public SelectedNotifyLanguageID: number = 1;
	public SuccessMessage: string = "";

	GuardianNotification: any = {
		Response: { RegistrationNbr: "" },
	};

	constructor(
		private userService: UserService,
		private studentService: PersonSelectorService,
		private guardiannotificationService: GuardianNotificationRegService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isKeyGenerated = false;
		this.user = this.userService.getCurrentUser();

		this.loadNotifyLanguages();

		this.subscription = this.studentService.onPersonSelectChange().subscribe((person) => {
			this.selectedStudent = person;

			this.guardiannotificationService
				.GuardianNotificationInfoGet(this.selectedStudent.PersonID)
				.subscribe((data) => this.GuardianNotificationInfoGet_Complete(data));
			this.GetRegistration();
			this.GuardianGetList();
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianNotificationInfoGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianNotificationInfoGet_Complete(data: any) {
		this.wsGuardianNotificationInfo = data;

		this.IsNotificationsForSchoolEnabled = this.wsGuardianNotificationInfo.IsNotificationsForSchoolEnabled;
		this.IsStudentSchoolNotificationEnabled = this.wsGuardianNotificationInfo.IsStudentSchoolNotificationEnabled;

		if (this.IsNotificationsForSchoolEnabled == false) {
			this.NotificationDisabledMessage = this.wsGuardianNotificationInfo.NotificationsForSchoolDisableMessage;
		} else {
			this.NotificationDisabledMessage = "";
		}

		this.SelectedNotifyLanguageID = this.wsGuardianNotificationInfo.NotifyLanguageID;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GetRegistration
	//
	//-----------------------------------------------------------------------------------------------------
	GetRegistration() {
		this.isBusy = true;

		var StudentID = this.selectedStudent.DesignatorID;
		var result = this.guardiannotificationService.GetRegistration(StudentID);

		result.subscribe(
			(response: any) => {
				this.GuardianNotification = response;

				if (this.GuardianNotification.Response == null || this.GuardianNotification.Response.RegistrationNbr == "") {
					this.isKeyGenerated = false;
				} else {
					this.isKeyGenerated = true;
				}

				this.isBusy = false;
			},
			(error) => {
				this.isBusy = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	CreateRegistration
	//
	//-----------------------------------------------------------------------------------------------------
	CreateRegistration() {
		this.isBusy = true;
		var StudentID = this.selectedStudent.DesignatorID;
		var result = this.guardiannotificationService.CreateRegistration(StudentID);

		result.subscribe(
			(response: any) => {
				this.GuardianNotification = response;

				if (this.GuardianNotification.Response == null || this.GuardianNotification.Response.RegistrationNbr == "") {
					this.isKeyGenerated = false;
				} else {
					this.isKeyGenerated = true;
				}

				this.isBusy = false;
			},
			(error) => {
				this.isBusy = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	CreateRegistrationReset
	//
	//-----------------------------------------------------------------------------------------------------
	CreateRegistrationReset() {
		this.isBusy = true;
		var StudentID = this.selectedStudent.DesignatorID;
		var result = this.guardiannotificationService.CreateRegistrationReset(StudentID);

		result.subscribe(
			(response: any) => {
				this.GuardianNotification = response;

				if (this.GuardianNotification.Response == null || this.GuardianNotification.Response.RegistrationNbr == "") {
					this.isKeyGenerated = false;
				} else {
					this.isKeyGenerated = true;
				}

				this.isBusy = false;
			},
			(error) => {
				this.isBusy = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianGetList
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianGetList() {
		this.SaveErrorMessage = "";
		this.SuccessMessage = "";
		this.SaveDone = "";

		var result = this.guardiannotificationService.GuardianGetList(this.selectedStudent.PersonID, this.selectedStudent.SchoolID);

		result.subscribe(
			(response: any) => {
				this.GuardianList = response;

				$.each(this.GuardianList, function (index, result) {
					result.IsSelected = true;
					result.IsImport = true;
				});
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	addGuardian
	//
	//-----------------------------------------------------------------------------------------------------
	addGuardian() {
		this.GuardianList.push({ Name: "", Email: "", IsImport: false });
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	removeGuardian
	//
	//-----------------------------------------------------------------------------------------------------
	removeGuardian(index) {
		this.GuardianList.splice(index, 1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	sendEmail
	//
	//-----------------------------------------------------------------------------------------------------
	sendEmail() {
		this.SaveErrorMessage = "";
		this.SuccessMessage = "";
		this.SaveDone = "";

		if (this.isKeyGenerated == false) {
			this.SaveErrorMessage = "Please generate a key";
			return;
		}

		let that = this;
		let validEmail = [];

		$.each(this.GuardianList, function (index, result) {
			if (result.Email && result.Name) {
				let newItem = { Email: result.Email, Name: result.Name };
				validEmail.push(newItem);
			}
		});

		if (validEmail.length == 0) {
			this.SaveErrorMessage = "Please enter one or more e-mail address.";
			return;
		}

		var StudentPersonID = this.selectedStudent.PersonID;
		var UserPersonID = this.user.personID;

		var result = this.guardiannotificationService.SendEmail(
			this.GuardianNotification.Response.RegistrationNbr,
			moment(this.GuardianNotification.Response.RegistrationExpireDT).format("MM/DD/YYYY"),
			StudentPersonID,
			UserPersonID,
			validEmail
		);

		result.subscribe(
			(response: any) => {
				this.SaveDone = "Done";
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	loadNotifyLanguages
	//
	//-----------------------------------------------------------------------------------------------------
	loadNotifyLanguages() {
		var result = this.guardiannotificationService.NotifyLanguageSelectList();
		result.subscribe(
			(response) => {
				this.lstNotifyLanguages = response;
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdateLanguage
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdateLanguage() {
		if (this.wsGuardianNotificationInfo == null || this.wsGuardianNotificationInfo.PersonID == null) {
			return;
		}

		this.isBusy = true;

		this.guardiannotificationService
			.NotifyLanguageModify(this.wsGuardianNotificationInfo.PersonID, this.SelectedNotifyLanguageID)
			.subscribe((data) => this.UpdateLanguageSendNotification_Complete(data));
	}

	UpdateLanguageSendNotification_Complete(data: any) {
		this.SuccessMessage = "";
		this.SaveErrorMessage = "";

		if (data == true) {
			this.SuccessMessage = "Notification language has been updated successfully.";
		} else {
			this.SaveErrorMessage = "ERROR: Could not update notification language";
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
